import * as axios from 'axios';

const API_DOMAIN = import.meta.env.VITE_APP_API_URL;
const API_VERSION = '/api';

const client = axios.create({
  baseURL: `${API_DOMAIN ?? ''}${API_VERSION}`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

export default client;
